import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import BaseCard from "../baseCard";
import MaterialTable from "material-table";
import {useQuery} from "@apollo/react-hooks";
import {GET_NEWS_LIST} from "../../../database/queries/newsQueries";
import tableIcons from "../../../constants/tableIcons";
import {AutoSizer} from 'react-virtualized';
import {notify} from "../../../utils/notify";
import Moment from "react-moment";
import CalendarStrings from "../../../constants/calendarStrings";

const useStyles = makeStyles({
    root: {},
});

const NewsCard = props => {
    const classes = useStyles();

    const {loading, error: getNewsListError, data, refetch} = useQuery(GET_NEWS_LIST, {
        variables: {
            orderList: ['updatedAt DESC']
        },
    });

    const columns = [
        {
            title: 'Type',
            width: '15%',
            field: 'newsType',
            headerStyle: {padding: 6, backgroundColor: '#ddd'},
            cellStyle: {padding: 6}
        },
        {
            title: 'Detail',
            width: '70%',
            field: 'newsDetail',
            headerStyle: {padding: 6, backgroundColor: '#ddd'},
            cellStyle: {padding: 6}
        },
        {
            title: 'Updated',
            width: '15%',
            render: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
            headerStyle: {padding: 6, backgroundColor: '#ddd'},
            cellStyle: {padding: 6}
        },
    ];

    useEffect(() => {
        if (getNewsListError) notify('getNewsListError', 'error', getNewsListError.message);
    }, [getNewsListError]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    if (loading) return <p>Loading ...</p>;
    if (getNewsListError) return `Error! ${getNewsListError.message}`;

    return (
        <AutoSizer>
            {({height, width}) => {
                const tableOptions = {
                    maxBodyHeight: height - 60,
                    padding: 'dense',
                    header: true,
                    paging: false,
                    showTitle: false,
                    search: false,
                    toolbar: false,
                    actionsColumnIndex: -1
                };
                return (
                    <BaseCard title={"JunctionBox.io News"} height={height} width={width}>
                        <div className={classes.root}>
                            {data && data.newsList && (
                                <MaterialTable
                                    icons={tableIcons}
                                    columns={columns}
                                    data={data.newsList}
                                    options={tableOptions}
                                />
                            )}
                        </div>
                    </BaseCard>
                );
            }}
        </AutoSizer>
    );
};

export default NewsCard
